import { useEffect, type RefObject } from 'react';

export function useClickOutside(
  ref: RefObject<HTMLElement | null>,
  handler: () => void,
): void {
  useEffect(() => {
    function onMouseDown(event: MouseEvent) {
      const node = ref.current;
      if (!node) return;
      if (event.target instanceof Node && node.contains(event.target)) return;
      if (
        event.target instanceof Element &&
        (event.target.closest('.react-select__menu-portal') ||
          event.target.closest('.react-select__menu'))
      ) {
        return;
      }
      handler();
    }

    document.addEventListener('mousedown', onMouseDown);
    return () => document.removeEventListener('mousedown', onMouseDown);
  }, [ref, handler]);
}
